// extracted by mini-css-extract-plugin
export default {"container":"j9qw_M","wrapper":"XitAvB","logo":"mPxEpE","message":"SLnypU","mobile":"n4oIe6"};